export default __webpack_public_path__ + "static/media/LectorAvatar.34ef6f8c.png";